import {VIEWS} from './consts';
import type {ChatOnboardingView} from './consts';

export function getNextView(
    currentView: ChatOnboardingView
): ChatOnboardingView | null | undefined {
    switch (currentView) {
        case VIEWS.YOUR_WEBSITE_VIEW:
            return VIEWS.INTERACTIVE_PREVIEW_VIEW;
        case VIEWS.INTERACTIVE_PREVIEW_VIEW:
            return VIEWS.EMBED_CHATBOT_VIEW;
        case VIEWS.EMBED_CHATBOT_VIEW:
        default:
            return undefined;
    }
}
